import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I sidehustled $72,167 last year, and what I wanna do next",
  "description": "",
  "published": "2018-01-03T00:00:00.000Z",
  "redirect_from": ["/blog/how-i-sidehustled-72167-last-year-and-what-i-wanna-do-next/swizec/8016"],
  "categories": "Business, Side Projects, sidehustle",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/01/ship-every-day-1.jpg",
        "alt": null
      }}></img></p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I'm writing my year in review post for 2017 and the thought of maintaining this trajectory in 2018 is making me shit my pants.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/948112227860492288"
      }}>{`January 2, 2018`}</a></blockquote>
    <p>{`2017 was bonkers. It started with an almost finished rewrite of `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js/"
      }}>{`React+D3v4`}</a>{` and a realization that I had `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/learned-6x-income-4-years/swizec/7340"
      }}>{`6x'd my income in 4 years`}</a>{`.`}</p>
    <h2 {...{
      "id": "-start-with-a-bang-"
    }}>{`💥 Start with a bang 💪`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/01/revenue-chart.jpg",
        "alt": null
      }}></img></p>
    <p>{`Then I got busy with the sponsored `}<a parentName="p" {...{
        "href": "http://reactnative.school"
      }}>{`Shoutem React Native school`}</a>{` project and everything else slowed down. Creating a new React Native app every other week is hard.`}</p>
    <p>{`So it took me 7 months of tweaking and updating `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js/"
      }}>{`React+D3v4`}</a>{` before it was ready. During this time, I also experimented with 1-on-1 coaching, tried `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/boutique-react-d3v4-workshop/swizec/7519"
      }}>{`selling React & D3 workshops to consumers`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/SwizecTeller"
      }}>{`started vlogging`}</a>{`.`}</p>
    <p>{`Vlogging is fun, great for brand building. People comment about it a lot in real life, but they don't press the magic Like button as much. ¯`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`Overall, the business was on life support. I flirted with the idea of giving up and living a normie life almost daily. It just seems so much easier.`}</p>
    <p>{`You go to work, you build what you're told, you offload your stress, do overtime when the boss likes it, and collect your fat paycheck. Being a Silicon Valley startup employee is easy.`}</p>
    <p>{`But it's not as fun.`}</p>
    <p>{`It's like my friend said, `}<em parentName="p">{`"If you quit your sidehustle, you're just gonna start a new one. Do you really think you can sit still and focus on One Thing?"`}</em></p>
    <p>{`No.`}</p>
    <p>{`Business picked up again in September. `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js"
      }}>{`React+D3v4`}</a>{` launched to little excitement and tiny fanfare. Preorders were great, but there's only so long you can keep people excited. When your product is 7 months late or more… heh 😅`}</p>
    <p>{`React+D3v4 did `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/9013-september-sidehustle-report-why-the-react-d3v4-launch/swizec/7837"
      }}>{`make `}{`\\`}{`\\`}{`\\`}{`$6.5k during launch`}</a>{`, so yay. Best sidehustle month in history. 💪`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Best sidehustle month ever! $9013 :partyparrot:`}<br parentName="p"></br><br parentName="p"></br>{`Here's how 👉 `}<a parentName="p" {...{
          "href": "https://t.co/lWVpZ5EpOI"
        }}>{`https://t.co/lWVpZ5EpOI`}</a><br parentName="p"></br><br parentName="p"></br>{`Also explains why it wasn't $90,013 😅 `}<a parentName="p" {...{
          "href": "https://t.co/kd3OOH160K"
        }}>{`pic.twitter.com/kd3OOH160K`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/915738664818245632"
      }}>{`October 5, 2017`}</a></blockquote>
    <p>{`Until October. October made me crap my pants.`}</p>
    <p>{`A workshop deal from Real World React fell in my lap and I `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/teaching-stubhub-react-redux/swizec/7860"
      }}>{`taught the StubHub SF team about React and Redux`}</a>{`. I also turned 30 and ran `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/16661-october-sidehustle-report/swizec/7883"
      }}>{`a birthday promotion that made almost `}{`\\`}{`\\`}{`\\`}{`$6k in 1 day`}</a>{`.`}</p>
    <p>{`Life was good. I was flying high. Then November was bad, then December was good again. `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/teaching-backend-devs-react-redux-stubhub-boston/swizec/7952"
      }}>{`Another StubHub workshop`}</a>{`. This time in Boston.`}</p>
    <h2 {...{
      "id": "breakdown"
    }}>{`Breakdown`}</h2>
    <p>{`For the curious, here's how the year breaks down.`}</p>
    <p><strong parentName="p">{`Total revenue: `}{`\\`}{`\\`}{`\\`}{`$72,167`}</strong></p>
    <p>{`Product sales: $37,240`}</p>
    <p>{`Packt royalties: $2,188`}</p>
    <p>{`Workshops: $19,684`}</p>
    <p>{`React Native School: $10,793`}</p>
    <p><strong parentName="p">{`Time investment: 864 hours`}</strong></p>
    <p>{`An average of 16 hours per week, making a respectable but not great $83/h.`}</p>
    <p><strong parentName="p">{`Total cost/investment: ~`}{`\\`}{`\\`}{`\\`}{`$43,000`}</strong></p>
    <p>{`Creating a measly post-cost pre-tax income of $33/hour.`}</p>
    <p>{`Better than minimum wage ($13/h) but talk to any engineer in Silicon Valley and they will tell you that number is just sad. I might as well give up now.`}</p>
    <p>{`But where's the fun in that?`}</p>
    <h2 {...{
      "id": "what-i-wanna-do-and-build-in-2018"
    }}>{`What I wanna do and build in 2018`}</h2>
    <p>{`Ultimately the goal for 2018 is to maintain this trajectory 👇`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/01/Screen-Shot-2018-01-03-at-01.16.17.png",
        "alt": "Screen Shot 2018-01-03 at 01.16.17"
      }}></img></p>
    <p>{`That means I gotta 2x my revenue. A cool $144,000. Preferably without 3x-ing the cost or worse.`}</p>
    <p>{`Why?`}</p>
    <p>{`Because freedom, that's why. Money is freedom.`}</p>
    <p>{`The more 💰 you have, the more you can do whatever you want. Something cool tickle your intellect? Wanna lock yourself in your room for 2 weeks and hack on something cool?`}</p>
    <p>{`Can't do that if you got bills to pay and nothing to pay them with.`}</p>
    <p>{`And I really want to do that.`}</p>
    <p>{`So how am I going to get there? I don't know yet to be honest. It's daunting.`}</p>
    <p>{`Hitting $70k was largely a matter of luck. There was no systematic process. No step-by-step plan I followed to get there. I just did things and hoped for the best.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/01/strategic-plan.jpg",
        "alt": null
      }}></img></p>
    <h3 {...{
      "id": "what-i-wanna-build"
    }}>{`What I wanna build`}</h3>
    <p>{`My strategic plan is a lot like that. I'm going to Do Things and then Stuff Will Happen. I need to work on that plan, but here's a list of some things plan to create 👇`}</p>
    <ul>
      <li parentName="ul">{`I wanna start `}<strong parentName="li">{`a daily video series. Learn X while you poop`}</strong>{`. 2-min videos teaching React and Redux based on my StubHub workshop. Expand if that goes well.`}</li>
    </ul>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I’ve been thinking of a project for 2018. Something like “Learn X on your morning poop” where X is javascript or CS or code or somesuch.`}<br parentName="p"></br><br parentName="p"></br>{`It would be a daily series of 2 or 3 min videos.`}<br parentName="p"></br><br parentName="p"></br>{`Should I do it? 🤔`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/946618544254541824"
      }}>{`December 29, 2017`}</a></blockquote>
    <p>{`Not sure yet if this will be a paid product, a membership product, or a purely brand building marketing product. Perhaps all 3.`}</p>
    <ul>
      <li parentName="ul">{`I’m going to `}<strong parentName="li">{`update `}<a parentName="strong" {...{
            "href": "https://es2017.io"
          }}>{`es2017.io`}</a></strong>{` for 2018 and add any new stuff that's coming to JavaScript. Keep that cheatsheet current.`}</li>
      <li parentName="ul">{`Create similar `}<strong parentName="li">{`interactive cheatsheets for React, Redux, MobX, and D3`}</strong>{`. Separate cheatsheet for each. They're great lead magnets for email subscribers.`}</li>
      <li parentName="ul">{`I want to build an `}<strong parentName="li">{`open source Make Your Own Blockchain`}</strong>{` library based on Redux, Firebase, and some WebRTC. `}<a parentName="li" {...{
          "href": "https://swizec.com/blog/blockchain-backed-redux-clone-105-lines-code/swizec/7980"
        }}>{`This is already in progress`}</a>{`. Not sure yet where I'm going with this, but it's scratching my intellectual curiosity real good.If the blockchain works, I want to use it for a project/product/startup I had in mind. Not ready yet to tell you what it is just yet. 😇`}</li>
    </ul>
    <hr></hr>
    <p>{`But that doesn't give me too many products I can sell, now does it? Guess I'm just gonna have to write books/guides/courses about the stuff I learn along the way.`}</p>
    <p>{`It feels dangerous to set that as a sort of throwaway side goal, but I want to get better at iterating and launching products quickly. When I learn a cool new piece of tech, or figure something out, it shouldn't take me 9 months to write a guide about it.`}</p>
    <h2 {...{
      "id": "what-needs-to-improve"
    }}>{`What needs to improve`}</h2>
    <p>{`And that's what needs to improve. I have to get better at launching infoproducts quicker. I'm already good at writing every day. I can sit down and blurt out thousands of words on a topic.`}</p>
    <p>{`Those `}<a parentName="p" {...{
        "href": "http://reactnative.school"
      }}>{`Shoutem React Native`}</a>{` articles, 4000+ words each? They took me 3 days to research and 2 days to write and video.`}</p>
    <p>{`If you put that in a book, it makes about 30 pages. I should definitely be able to launch more books and courses. Just gotta find the fire under butt. 🔥🍑`}</p>
    <p>{`Another very important part of the sidehustle that I need to improve is `}<a parentName="p" {...{
        "href": "http://swizec.com"
      }}>{`http://swizec.com`}</a>{`. The homepage hasn't been updated in 3 years and doesn't even mention my sidehustle, which is ridiculous.`}</p>
    <p>{`My blog is also in dire need of an update. It doesn't work well on mobile, syntax highlighting is all messed up, and it feels crufty and weird looking.`}</p>
    <p>{`So I'm gonna fix that. But I'm going to hire someone to help me.`}</p>
    <p>{`Yes, I'm fundamentally a web developer. Yes, I can do it on my own. And yet I haven't found the time to do it in years. 😅`}</p>
    <p>{`Oh, and I have to work on my quote unquote Growth Engine. That's the part of the business that brings in new people every day that you can talk to. I have some ideas 🤔`}</p>
    <h2 {...{
      "id": "fin"
    }}>{`Fin`}</h2>
    <p><img parentName="p" {...{
        "src": "/11599cb428fc78f7561a847af46e51c4/media-POekkUcKs16gg-200.gif",
        "alt": null
      }}></img></p>
    <p>{`🤘`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      